<ph-stack gap="snug">
    <ph-file-upload *ngIf="canAddMore"
                    [accept]="accept"
                    [multiple]="multiple"
                    [disabled]="disabled"
                    [heading]="dropHeading"
                    [action]="multiple ? 'Browse files' : 'Browse file'"
                    [hint]="shownHint"
                    [error]="rejectError"
                    (ph-files)="onFiles($event)"
                    (ph-reject)="onRejected($event)"></ph-file-upload>

    <ph-list-row *ngFor="let file of selected; let i = index; trackBy: trackByIndex"
                 plain
                 [heading]="file.name"
                 [meta]="size(file)">
        <ph-file-icon slot="leading" [name]="file.name"></ph-file-icon>
        <ph-compact-button slot="actions"
                           variant="ghost"
                           size="large"
                           destructive
                           icon="trash"
                           [attr.aria-label]="'Remove ' + file.name"
                           [disabled]="disabled"
                           (click)="remove(i)"></ph-compact-button>
    </ph-list-row>

    <ph-hint *ngFor="let error of errors; trackBy: trackByIndex" [hasError]="true">{{ error }}</ph-hint>
</ph-stack>
